import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";
import { Store } from "react-notifications-component";
import { developAxios } from "../axios.config";
import {
	FilterFn,
	FilterMeta,
	Row,
	createColumnHelper,
	flexRender,
	getCoreRowModel,
	getFilteredRowModel,
	useReactTable,
	getPaginationRowModel,
} from "@tanstack/react-table";
import { rankItem } from "@tanstack/match-sorter-utils";
import { useQuery } from "react-query";
import CopyLinkDialog from "./CopyLinkDialog";
import {
	TableContainer,
	Paper,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from "@mui/material";

type CodingQuestion = {
	category: string;
	company?: Array<string>;
	name: string;
	outOfScore: number;
	questionWeigh: number;
	_id: string;
};

const columnHelper = createColumnHelper<CodingQuestion>();

const columns = [
	columnHelper.accessor("_id", {
		cell: (info) => info.getValue(),
		// footer: info => info.column.id,
	}),
	columnHelper.accessor("name", {
		cell: (info) => info.getValue(),
		header: "Name",
	}),
	columnHelper.accessor("category", {
		cell: (info) => info.getValue(),
		header: "Category",
	}),
	columnHelper.accessor("outOfScore", {
		cell: (info) => info.getValue(),
		header: "Out Of Score",
	}),
];

const CodingExamCreating = () => {
	const [questionsArray, setquestionsArray] = useState<
		Array<{
			id: string;
			outOfScore: number;
		}>
	>([]);
	const [nameoftheexam, setnameoftheexam] = useState("");
	const [timeoftheexam, settimeoftheexam] = useState("");
	const [globalFilter, setGlobalFilter] = useState("");
	const [typeOfExam, settypeOfExam] = useState("");
	const [courses, setCourses] = useState<
		Array<{ name: string; _id: string }>
	>([]);
	const [course, setcourse] = useState("");
	const [displayDialog, setDisplayDialog] = useState(false);
	const [examId, setExamId] = useState<string>("");
	const [examDate, setExamDate] = useState<string>("");
	const [examEndTime, setExamEndTime] = useState<string>("");

	const fuzzyFilter: FilterFn<any> = (
		row: Row<any>,
		columnId: string,
		value: any,
		addMeta: (meta: FilterMeta) => void
	) => {
		let updated_val = value;
		let compilerRegex = /compiler\/([a-zA-Z0-9]{24})/i;
		let match = compilerRegex.exec(updated_val);
		if (match) {
			updated_val = match[1];
		}
		const itemRank = rankItem(row.getValue(columnId), updated_val);

		addMeta({
			itemRank,
		});

		return itemRank.passed;
	};

	const { data: codingData, isLoading } = useQuery(
		"GetAllQuestionAdmin",
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				questions: CodingQuestion[];
			}>("/GetAllQuestionAdmin")
	);
	const table = useReactTable({
		data: codingData?.data.questions || [],
		columns,
		getCoreRowModel: getCoreRowModel(),
		state: {
			globalFilter,
		},
		onGlobalFilterChange: setGlobalFilter,
		filterFns: {
			fuzzy: fuzzyFilter,
		},
		globalFilterFn: fuzzyFilter,
		getFilteredRowModel: getFilteredRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
	});

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data: { courses: Array<{ name: string; _id: string }> }) => {
				setCourses(data?.courses);
			});
	}, []);

	function SubmitTheExam() {
		const Date_to_Number = (date: string) => {
			const new_date = new Date(date);
			return new_date.getTime();
		};
		let data = {};
		let totalScore = 0;
		questionsArray.forEach((val) => (totalScore += val.outOfScore));
		data = {
			name: nameoftheexam,
			questions: questionsArray.map((val) => val.id),
			timer: timeoftheexam,
			startTime: "0",
			endTime: "0",
			examEndTime: Date_to_Number(examEndTime),
			examDate: Date_to_Number(examDate),
			courseid: course,
			category: "-",
			typeOfExam: typeOfExam,
			genre: "-",
			language: "C",
			type: "Technical Exam",
			topic: "Data Structures",
			Subtopic: "-",
			outOfScore: totalScore,
		};
		console.log(examDate, examEndTime);

		const notifyPopup = (msg: string) => {
			Store.addNotification({
				title: "Success!",
				message: msg,
				type: "success",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};

		developAxios(localStorage.getItem("token") || "")
			.post("/createExamCoding", data)
			.then(({ data }) => {
				setnameoftheexam("");
				settimeoftheexam("");
				setquestionsArray([]);
				settypeOfExam("");
				setDisplayDialog(true);
				notifyPopup(data.message);
				setExamId(data.exam._id);
			})
			.catch(({ response }) => {
				alert(response.data.error);
			});
	}

	function handleRowSelect(val: CodingQuestion) {
		setquestionsArray((prev) => {
			let found = false;
			let existing_val = prev.filter((value) => {
				if (value.id === val._id) {
					found = true;
					return false;
				} else {
					return true;
				}
			});

			if (found) {
				return existing_val;
			} else {
				return [
					...existing_val,
					{
						id: val._id,
						outOfScore: val.outOfScore,
					},
				];
			}
		});
	}

	function closeDialog() {
		setDisplayDialog(false);
	}

	return (
		<>
			<CopyLinkDialog
				open={displayDialog}
				onClose={closeDialog}
				examLink={`https://www.cantileverlabs.com/codingexam/${examId}`}
				title="Copy Coding Exam Links"
			/>
			<div className="text-center">
				<br />
				<button
					onClick={SubmitTheExam}
					className="btn btn-danger btn-lg"
				>
					Create The exam
				</button>
				<br />
				<br />
				<p>Name of the exam</p>
				<input
					type="text"
					value={nameoftheexam}
					onChange={(e) => setnameoftheexam(e.target.value)}
					className="form-control mx-auto w-50"
					placeholder="Enter the name of the exam"
				/>
				<p>Enter the time for the exam</p>
				<input
					type="text"
					className="form-control mx-auto w-50"
					// value={timeoftheexam}
					onChange={(e) => settimeoftheexam(e.target.value)}
					placeholder="Enter the Time of the exam"
				/>
				<p>Start Date Time</p>
				<input
					type="datetime-local"
					className="form-control mx-auto w-50"
					value={examDate}
					onChange={(e) => {
						setExamDate(e.target.value);
					}}
					placeholder="Enter the Time of the exam"
				/>
				<p>End Date Time</p>
				<input
					type="datetime-local"
					className="form-control mx-auto w-50"
					value={examEndTime}
					onChange={(e) => setExamEndTime(e.target.value)}
					placeholder="Enter the Time of the exam"
				/>
				<br />
				Choose the course for the exam
				<select
					className={`form-control mx-auto w-50`}
					aria-label="Default select example"
					id=""
					value={course}
					onChange={(e) => {
						setcourse(e.target.value);
					}}
				>
					<option value="">Select Course</option>
					{courses.map((val, index) => {
						return (
							<option key={index} value={val?._id}>
								{val?.name}
							</option>
						);
					})}
				</select>
				<br />
				<input
					type="text"
					className="form-control mx-auto w-50"
					value={typeOfExam}
					onChange={(e) => settypeOfExam(e.target.value)}
					placeholder="Write the type of the exam"
				/>
				<br />
				<div>
					Questions Added = {questionsArray.length}
					<br />
					<div className="row container form-control mx-auto">
						<p> Select the questions for the exam </p>

						<div></div>
					</div>
				</div>
				<div>
					<DebouncedInput
						value={globalFilter ?? ""}
						onChange={(value) => setGlobalFilter(String(value))}
						className="p-2 font-lg shadow border border-block w-[50%] mt-4"
						placeholder="Search all columns..."
					/>
				</div>
				<TableContainer component={Paper} sx={{ mt: 4 }}>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead className="bg-sky-600 font-semibold">
							{table.getHeaderGroups().map((headerGroup) => (
								<TableRow key={headerGroup.id}>
									{headerGroup.headers.map((header) => (
										<TableCell
											key={header.id}
											style={{
												color: "#fff",
												fontWeight: 700,
											}}
										>
											{header.isPlaceholder
												? null
												: flexRender(
														header.column.columnDef
															.header,
														header.getContext()
												  )}
										</TableCell>
									))}
								</TableRow>
							))}
						</TableHead>
						<TableBody>
							{table.getRowModel().rows.map((row) => (
								<TableRow
									key={row.id}
									onClick={() =>
										handleRowSelect(row.original)
									}
									className={
										questionsArray.filter(
											(val) => val.id === row.original._id
										)[0]
											? "bg-orange-300"
											: ""
									}
								>
									{row.getVisibleCells().map((cell) => (
										<TableCell key={cell.id}>
											{flexRender(
												cell.column.columnDef.cell,
												cell.getContext()
											)}
										</TableCell>
									))}
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
				<div className="flex items-center gap-2 my-5 justify-center">
					<button
						className="border rounded p-1"
						onClick={() => table.setPageIndex(0)}
						disabled={!table.getCanPreviousPage()}
					>
						{"<<"}
					</button>
					<button
						className="border rounded p-1"
						onClick={() => table.previousPage()}
						disabled={!table.getCanPreviousPage()}
					>
						{"<"}
					</button>
					<button
						className="border rounded p-1"
						onClick={() => table.nextPage()}
						disabled={!table.getCanNextPage()}
					>
						{">"}
					</button>
					<button
						className="border rounded p-1"
						onClick={() =>
							table.setPageIndex(table.getPageCount() - 1)
						}
						disabled={!table.getCanNextPage()}
					>
						{">>"}
					</button>
					<span className="flex items-center gap-1">
						<div>Page</div>
						<strong>
							{table.getState().pagination.pageIndex + 1} of{" "}
							{table.getPageCount()}
						</strong>
					</span>
					<select
						value={table.getState().pagination.pageSize}
						onChange={(e) => {
							table.setPageSize(Number(e.target.value));
						}}
					>
						{[10, 20, 30, 40, 50].map((pageSize) => (
							<option key={pageSize} value={pageSize}>
								Show {pageSize}
							</option>
						))}
					</select>
				</div>
			</div>
		</>
	);
};

export default CodingExamCreating;

function DebouncedInput({
	value: initialValue,
	onChange,
	debounce = 500,
	...props
}: {
	value: string | number;
	onChange: (value: string | number) => void;
	debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
	const [value, setValue] = React.useState(initialValue);

	React.useEffect(() => {
		setValue(initialValue);
	}, [initialValue]);

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			onChange(value);
		}, debounce);

		return () => clearTimeout(timeout);
	}, [value]);

	return (
		<input
			{...props}
			value={value}
			onChange={(e) => setValue(e.target.value)}
		/>
	);
}
